import type { DraftInput, DraftMedia } from '../../../shared/drafts';
import type { TrainLevel } from './levelProgression';

type PreviewableChoice = DraftInput['questions'][number]['choices'][number] & {
  id?: string;
  media?: DraftMedia | null;
};

type PreviewableQuestion = Omit<DraftInput['questions'][number], 'choices'> & {
  media?: DraftMedia | null;
  choices: PreviewableChoice[];
};

type PreviewableDraft = {
  maxLevels: number;
  questions: PreviewableQuestion[];
};

export function draftToTrainLevels(draft: PreviewableDraft): TrainLevel[] {
  return Array.from({ length: draft.maxLevels }, (_, levelIndex) => {
    const level = levelIndex + 1;
    return {
      id: level,
      questions: draft.questions
        .filter((question) => question.levels.includes(level))
        .map((question, questionIndex) => {
          if (!question.choices.some((choice) => choice.isCorrect)) {
            throw new Error(`${level}. seviyedeki ${questionIndex + 1}. sorunun doğru cevabı yok.`);
          }
          return {
            id: `level-${level}-question-${questionIndex + 1}`,
            prompt: question.prompt,
            wagonStyle: question.wagonStyle ?? 'wide',
            choices: question.choices.map((choice, choiceIndex) => ({
              id: choice.id ?? `level-${level}-question-${questionIndex + 1}-choice-${choiceIndex + 1}`,
              label: choice.text,
              correct: choice.isCorrect,
              ...(choice.media ? { mediaUrl: choice.media.url } : {}),
            })),
            ...(question.media ? { promptMediaUrl: question.media.url } : {}),
          };
        }),
    };
  });
}
